// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export enum QuotingType
{
    None = -1,
    TickCost_TickSize = 0,
    LotSize = 1
};